import type { ArchiveSnapshotSummary, ArchivedOfficialReference } from './apiClient';

export interface ArchiveHistoryTimelineItem {
  id: string;
  occurredAt: number;
  dateLabel: string;
  reasonLabel: string;
  successorName: string | null;
  successorId: string | null;
  isLatest: boolean;
}

const ARCHIVE_REASON_LABELS: Record<string, string> = {
  replaced_after_election: 'Replaced after election',
  replaced_in_latest_roster: 'Replaced in latest roster',
  missing_from_latest_roster: 'Missing from latest roster',
};

function humanizeArchiveReason(reason: string | null): string {
  if (!reason) return 'Archived';
  const label = ARCHIVE_REASON_LABELS[reason] ?? reason.replace(/_/g, ' ');
  return label.charAt(0).toUpperCase() + label.slice(1);
}

export function buildArchiveHistoryTimeline(
  archiveHistory: ArchiveSnapshotSummary[],
  replacedByOfficial: ArchivedOfficialReference | null,
): ArchiveHistoryTimelineItem[] {
  return archiveHistory.map((snapshot, index) => ({
    id: snapshot.id,
    occurredAt: snapshot.archived_at,
    dateLabel: new Date(snapshot.archived_at).toLocaleDateString('en-US', { timeZone: 'UTC' }),
    reasonLabel: humanizeArchiveReason(snapshot.archive_reason),
    successorName: snapshot.replaced_by_official_id && replacedByOfficial?.id === snapshot.replaced_by_official_id
      ? replacedByOfficial.name
      : null,
    successorId: snapshot.replaced_by_official_id ?? null,
    isLatest: index === 0,
  }));
}
